import { CommonSectionIds } from '../common.models';

export const FlexSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    ConfigureAlarms: CommonSectionIds.ConfigureAlarms,
    DataDelivery: CommonSectionIds.DataDelivery,
    DialogActions: CommonSectionIds.DialogActions,

    FlexInfo: 'flex-info-section',
    Mp2BasicInfo: 'flex-info-mp2-basic-info',
};

export enum FlexBasicInfoFieldId {
    ScanMode = 'flex-basic-info-scanMode',
}

export enum FlexInfoFieldId {
    // Sensor 1 fields
    Sensor1 = 'flex-info-sensor1',
    MP1 = 'flex-info-mp1',
    Channel1 = 'flex-info-channel1',
    PhysicalOffset1 = 'flex-info-physicalOffset1',
    PhysicalOffsetRef1 = 'flex-info-physicalOffsetRef1',
    Silt1 = 'flex-info-silt1',
    SiltEditButton1 = 'flex-info-siltEditButton1',
    FlowType1 = 'flex-info-flowType1',


    // Sensor 2 fields
    Sensor2 = 'flex-info-sensor2',
    MP2 = 'flex-info-mp2',
    Channel2 = 'flex-info-channel2',
    PhysicalOffset2 = 'flex-info-physicalOffset2',
    PhysicalOffsetRef2 = 'flex-info-physicalOffsetRef2',

    Silt2 = 'flex-info-silt2',
    SiltEditButton2 = 'flex-info-siltEditButton2',
    FlowType2 = 'flex-info-flowType2',

    Mp1DepthEntityType = 'flex-info-mp1-depth-entity-type',
    Mp1VelocityEntityType = 'flex-info-mp1-velocity-entity-type',
    Mp1SensorPreferencesTitle = 'mp1-sensor-preferences-title',
    Mp2DepthEntityType = 'flex-info-mp2-depth-entity-type',
    Mp2VelocityEntityType = 'flex-info-mp2-velocity-entity-type',
    Mp2SensorPreferencesTitle = 'mp2-sensor-preferences-title',

    CreateFlexTextRow = 'create-flex-text-row',
    CreateFlexInfoText = 'create-flex-info-text',
    CreateFlexWaitText = 'create-flex-wait-text',
    CreateFlexErrorText = 'create-flex-error-text'
}

export enum Mp2BasicInfoFieldId {
    StatusSection = 'mp2-basic-info-status-section',
    QFinalEntityID = 'mp2-basic-info-qFinalEntityID',
    AssignedRainGauge = 'mp2-basic-info-assignedRainGauge',
    Status = 'mp2-basic-info-status',
    MaintenanceInterval = 'mp2-basic-info-maintenanceInterval',
    MaintenanceEnd = 'mp2-basic-info-maintenanceEnd',
    InstallationType = 'mp2-basic-info-installationType',
    InstallationShapeType = 'mp2-basic-info-installationShapeType',
    InstallationDate = 'mp2-basic-info-installationDate',
    CustomPropertiesSection = 'mp2-basic-info-custom-properties-section',
    CustomPropertyKey = 'mp2-basic-info-custom-property-key',
    CustomPropertyValue = 'mp2-basic-info-custom-property-value',
    InstallationRow = 'mp2-installation-row',
}


export enum DynamicPhysicalOffsetFieldId {
    PhysicalOffset0 = 'physical-offset-0',
    PhysicalOffsetRef0 = 'physical-offset-ref-0',

    PhysicalOffset1 = 'physical-offset-1',
    PhysicalOffsetRef1 = 'physical-offset-ref-1',
}

export const FLEX_MONITOR_CONFIGURATION_CONSTANTS = {
    ftpdeliverynormal: 0,
    ftpdeliveryfast: 0,
    ftpfolder: '',
    ftppassword: '',
    ftpusername: '',
    ftpserver: '',
    ftpmode: 'Active',
    ftpformat: 'ADS',
    storetemperature: false,
    storebattery: 1,
};
